import { DialogProps } from "@mcleod/components";
import { AbstractPanelOpenTree } from "./AbstractPanelOpenTree";

export class PanelOpenModel extends AbstractPanelOpenTree {
    override getDialogProps(): Partial<DialogProps> {
        return {
            ...super.getDialogProps(),
            cursor: null
        };
    }

    protected override getTitle(): string {
        return "Model Selection";
    }

    getApiName(): string {
        return "metadata/models";
    }

    getCustomizedTooltip(): string {
        return "This is a customized model.";
    }
}
